import {ApThemeSwatchInfoProps} from '../../@atoms/to_content/color_swatches/color_swatches.atom'
import themeCustomSrc from './theme.module.scss'

const themeInfoArray: Array<ApThemeSwatchInfoProps> = []

function GetThemeInfo({...src}) {
  Object.keys(src).map(function (objKey) {
    const objKeyVal = src[objKey]
    themeInfoArray.push({
      id: objKey,
      title: objKey,
      code: objKeyVal,
      txtColor: themeCustomSrc.high_emphasis_grey,
    })
    return themeInfoArray
  })
}
GetThemeInfo(themeCustomSrc)

export default themeInfoArray
